"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  rpc: {},
  types: {
    CallOf: 'Call',
    DispatchTime: {
      _enum: {
        At: 'BlockNumber',
        After: 'BlockNumber'
      }
    },
    ScheduleTaskIndex: 'u32',
    DelayedOrigin: {
      delay: 'BlockNumber',
      origin: 'PalletsOrigin'
    }
  }
};
exports.default = _default;